import { Components, Theme } from '@mui/material';

import { colors } from '../colors';
import { pxToRem } from '../utils';

// eslint-disable-next-line prefer-destructuring
const color = colors.neutral[900];

export const getTypography = (rootFontSize = 16, fontFamily: string) => {
    // Evaneos b2b-ui values
    const body = {
        color,
        fontSize: pxToRem(16, rootFontSize),
        fontWeight: 400,
        lineHeight: pxToRem(24, rootFontSize),
    };

    const titleMoretXL = {
        color,
        fontFamily: 'Moret, "Times New Roman", serif',
        fontSize: pxToRem(40, rootFontSize),
        fontWeight: 800,
        lineHeight: pxToRem(48, rootFontSize),
    };

    const titleMoretL = {
        color,
        fontFamily: 'Moret, "Times New Roman", serif',
        fontSize: pxToRem(28, rootFontSize),
        fontWeight: 800,
        lineHeight: pxToRem(40, rootFontSize),
    };

    const titleXL = {
        color,
        fontSize: pxToRem(32, rootFontSize),
        fontWeight: 800,
        lineHeight: pxToRem(40, rootFontSize),
    };

    const titleL = {
        color,
        fontSize: pxToRem(24, rootFontSize),
        fontWeight: 700,
        lineHeight: pxToRem(32, rootFontSize),
    };

    const titleM = {
        color,
        fontSize: pxToRem(20, rootFontSize),
        fontWeight: 700,
        lineHeight: pxToRem(28, rootFontSize),
    };

    const titleS = {
        color,
        fontSize: pxToRem(16, rootFontSize),
        fontWeight: 700,
        lineHeight: pxToRem(24, rootFontSize),
    };

    const titleXS = {
        color,
        fontSize: pxToRem(16, rootFontSize),
        fontWeight: 400,
        lineHeight: pxToRem(24, rootFontSize),
    };

    const annotation = {
        color,
        fontSize: pxToRem(14, rootFontSize),
        fontWeight: 400,
        lineHeight: '157%',
    };

    const caption = {
        color,
        fontSize: pxToRem(12, rootFontSize),
        fontWeight: 400,
        lineHeight: pxToRem(16, rootFontSize),
    };

    const badge = {
        color,
        fontSize: pxToRem(14, rootFontSize),
        fontWeight: 700,
        lineHeight: pxToRem(16, rootFontSize),
    };
    const subtitle = {
        color,
        fontSize: pxToRem(14, rootFontSize),
        fontWeight: 400,
        lineHeight: pxToRem(20, rootFontSize),
    };
    const overline = {
        color,
        fontSize: pxToRem(14, rootFontSize),
        fontWeight: 600,
        lineHeight: pxToRem(16, rootFontSize),
    };
    return {
        fontFamily: fontFamily,
        fontSize: 16,
        htmlFontSize: rootFontSize,
        caption,
        h1: titleXL,
        h2: titleL,
        h3: titleM,
        h4: titleS,
        h5: titleXS,
        h6: titleXS,
        subtitle1: subtitle,
        subtitle2: subtitle,
        body1: body,
        body2: subtitle,
        overline,
        // Evaneos legacy tokens, you should now use the default material ones
        titleXL,
        titleL,
        titleM,
        titleS,
        annotation,
        body,
        badge,
        titleMoretXL,
        titleMoretL,
    };
};

export const MuiTypography: Components<Theme>['MuiTypography'] = {
    defaultProps: {
        variantMapping: {
            titleL: 'h2',
            titleM: 'h3',
            titleS: 'h4',
            body: 'p',
            badge: 'span',
            annotation: 'span',
            caption: 'span',
            titleMoretXL: 'h1',
            titleMoretL: 'h2',
        },
    },
};
